<stx-generic-wide-page>
  <stx-page-header [name]="'practitioners' | translate"></stx-page-header>
  <stx-practitioner-search></stx-practitioner-search>
  <div class="data-section">
    <stx-data-table
      [dataProvider]="searchResultsDataProvider"
      [config]="{ topPaginator: true, hideUninitialized: true, stickyColumnClass: 'sticky-second' }"
    >
      <tr mat-row *matRowDef="let row; columns: []" [class.data-table-inactive]="row.practitioner?.inactive"></tr>
    </stx-data-table>
  </div>
</stx-generic-wide-page>
